import React from 'react';
import '../styles/About.css';

const About = () => {
  return (
    <section id="about" className="about" data-testid="about-section">
      <div className="about-container">
        <h2 className="section-title">About</h2>
        <div className="about-content">
          <div className="about-image-wrapper">
            <img
              src="/about-kate.png"
              alt="Kate Sewell"
              className="about-image"
              data-testid="about-image"
            />
          </div>
          <div className="about-text" data-testid="about-text">
            <h3 className="about-headline">2D Character Animator with a technical edge.</h3>
            <p className="about-paragraph">
              I am an animator who understands the mechanics behind the movement. My primary focus is delivering high-quality, expressive character performance, backed by hands-on technical rigging experience that ensures assets are clean, efficient, and production-ready.
            </p>

            <h4 className="about-subheading">Production Leadership</h4>
            <ul className="about-list">
              <li><strong>Animation Lead</strong> | <em>Creepy Cable</em></li>
              <li><strong>Animation Lead</strong> | <em>Sand Wars</em></li>
            </ul>

            <h4 className="about-subheading">Technical Stack &amp; Credentials</h4>
            <ul className="about-list">
              <li><strong>Primary Focus:</strong> 2D Character Animation, Performance, Storyboarding</li>
              <li><strong>Technical Specialization:</strong> Character Rigging &amp; Pipeline Optimization</li>
              <li><strong>Certifications:</strong> Toon Boom Harmony &amp; Adobe Photoshop</li>
              <li><strong>Education:</strong> B.F.A. 2D Animation, SCAD (Class of May 2027)</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
